import BaseDecorator from "./BaseDecorator";
import AttachmentDecorator from "./AttachmentDecorator";
import CompanyDecorator from "./CompanyDecorator";
import ProductVariantDecorator from "./ProductVariantDecorator";

export default class ProductDecorator extends BaseDecorator {
  transformData(data) {
    return super.transformData({
      ...data,

      company: new CompanyDecorator(data.company),

      product_variants: data.product_variants
        .map((x) => new ProductVariantDecorator(x))
        .sort((a, b) => a.position - b.position),
    });
  }

  get has_pricing() {
    return this.product_type !== "coupon";
  }

  get preview_url() {
    return this.saas_preview_url || this.marketplace_preview_url;
  }

  get saas_preview_url() {
    if (this.published_on_saas) {
      return this.company.getSaasWebsiteUrl(`/p/${this.id}`, {
        pt: this.preview_token,
      });
    } else {
      return null;
    }
  }

  get reseller_preview_url() {
    if (this.published_on_saas) {
      return this.company.getResellerWebsiteUrl(`/p/${this.id}`, {
        pt: this.preview_token,
      });
    } else {
      return null;
    }
  }

  get marketplace_preview_url() {
    if (this.has_active_st_agent_deal) {
      return this.company.getMarketplaceWebsiteUrl(`/p/${this.id}`, {
        pt: this.preview_token,
      });
    } else {
      return null;
    }
  }

  get active() {
    return this.status === "published";
  }

  // Public page of this offer as linked from the panel, seen from
  // `viewingCompany`'s perspective: its own SaaS site when it runs one,
  // otherwise the marketplace. Returns null when neither channel is
  // available — an offer pulled from the marketplace (no active ST agent
  // deal) owned by a company without a SaaS site has no public page at all,
  // and callers must not render a link to it.
  //
  // Host building — including stripping the legacy "old." prefix — belongs
  // to CompanyDecorator; nothing here assembles URLs by hand.
  getPreviewUrlFor(viewingCompany) {
    if (viewingCompany.enable_saas && viewingCompany.saas_host) {
      return `${viewingCompany.saas_url}/p/${this.id}-${this.slug}`;
    }

    return this.marketplace_preview_url;
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductDecorator.js